import React from "react";
import { useParams } from "react-router-dom";
import NavbarDashboard from "../components/NavbarDashboard";
import Sidebar from "../components/Sidebar";
import { useStateContext } from "../context/ContextProvider";
import { useState } from "react";
import "../components/MyRecipe/Tabs.css";
import ReactShareFavourites from "../components/Favourites/ReactShareFavourites";

const ShowMyFavourites = () => {
  const { activeMenu, favouriteRecipes, user } = useStateContext();
  const { id } = useParams();
  const { username } = user;

  const [toggleState, setToggleState] = useState(1);
  const title = favouriteRecipes[id - 1].title;
  const category = favouriteRecipes[id - 1].category;
  const peopleServed = favouriteRecipes[id - 1].people_served;
  const country = favouriteRecipes[id - 1].country;
  const cookingTime = favouriteRecipes[id - 1].cooking_time;
  const ingredients = favouriteRecipes[id - 1].ingredients;
  const procedure = favouriteRecipes[id - 1].procedure;
  const videoLink = favouriteRecipes[id - 1].video_link;
  const imageUrl = favouriteRecipes[id - 1].image_url;

  const toggleTab = (index) => {
    setToggleState(index);
  };

  return (
    <div>
      <div className="flex relative">
        <div className="fixed" style={{ zIndex: "100000" }}>
          {activeMenu ? (
            <div className="w-72 fixed sidebar bg-white ">
              <Sidebar />
            </div>
          ) : (
            <div className="w-0">
              <Sidebar />
            </div>
          )}
        </div>

        <div
          className={
            activeMenu
              ? "bg-main-bg min-h-screen md:ml-72 w-full  "
              : "bg-main-bg w-full min-h-screen flex-2 "
          }
        >
          <div className="fixed md:static bg-main-bg navbar w-full">
            <NavbarDashboard />

            <div className="container">
              <div className="bloc-tabs">
                <button
                  className={
                    toggleState === 1 ? "tabs active-tabs font-bold" : "tabs"
                  }
                  onClick={() => toggleTab(1)}
                >
                  Step by Step Guide
                </button>
                <button
                  className={
                    toggleState === 2 ? "tabs active-tabs font-bold" : "tabs"
                  }
                  onClick={() => toggleTab(2)}
                >
                  Video Tutorial
                </button>
              </div>

              <div className="content-tabs">
                <div
                  className={
                    toggleState === 1 ? "content  active-content" : "content"
                  }
                >
                  <div className="grid md:grid-cols-1 lg:grid-cols-2 ">
                    <div>
                      <h3 className="font-bold text-lg py-4 tracking-normal">
                        Recipe Creator:{" "}
                        <span className="font-normal">
                          {favouriteRecipes[id - 1].user.username}
                        </span>
                      </h3>

                      <div className="h-1/2 w-full">
                        <img
                          className="h-full w-full object-cover rounded-md"
                          src={imageUrl}
                          alt="recipe"
                        />
                      </div>

                      <div className="pt-10 flex flex-col gap-10">
                        

                        <div>
                          <h2 className="font-bold sm:text-base md:text-base lg:text-lg tracking-normal">
                            Share on social media
                          </h2>
                          <ReactShareFavourites favouriteVideo={videoLink} />
                        </div>
                      </div>
                    </div>
                    <div className="px-10">
                      <h1 className="font-extrabold text-3xl mt-16">{title}</h1>
                      <div className="flex justify-between py-4 ">
                        <div>
                          <h3 className="font-semibold md:text-sm lg:text-base tracking-normal">
                            Servings
                          </h3>
                          <h3 className="">{peopleServed}</h3>
                        </div>
                        <div>
                          <h3 className="font-semibold md:text-sm lg:text-base tracking-normal">
                            Category
                          </h3>
                          <h3 className="">{category}</h3>
                        </div>
                        <div>
                          <h3 className="font-semibold md:text-sm lg:text-base tracking-normal">
                            Cooking Time
                          </h3>
                          <h3 className="">{cookingTime}</h3>
                        </div>
                        <div>
                          <h3 className="font-semibold md:text-sm lg:text-base tracking-normal">
                            Country
                          </h3>
                          <h3 className="">{country}</h3>
                        </div>
                      </div>
                      <div>
                        <div className="border-b-2"></div>
                        <div className="pt-8">
                          <h2 className="font-bold text-xl tracking-normal">
                            Ingredients
                          </h2>
                          <h3 className="ml-6">
                            {ingredients.split(".").map((ingredient) => {
                              return (
                                <ul className="list-disc">
                                  <li>{ingredient}</li>
                                </ul>
                              );
                            })}
                          </h3>
                        </div>
                        <div className="pt-8">
                          <h2 className="font-bold text-xl tracking-normal">
                            Procedures
                          </h2>
                          <h3 className="ml-6">
                            {procedure.split(".").map((prod) => {
                              return (
                                <ul className="list-disc">
                                  <li>{prod}</li>
                                </ul>
                              );
                            })}
                          </h3>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  className={
                    toggleState === 2 ? "content  active-content" : "content"
                  }
                >
                  <div className="h-screen">
                    <iframe
                      src={videoLink}
                      frameborder="0"
                      allow="autoplay; encrypted-media"
                      allowfullscreen
                      title="video"
                      className="w-full h-3/4"
                    />
                  </div>

                  <hr />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShowMyFavourites;
